
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationB as ObiLocationBElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-b.js';
 
 
 

 
 export const ObiLocationB = createComponent({
   react: React,
   tagName: 'obi-location-b',
   elementClass: ObiLocationBElement,
   events: {
     
   }
  });
 
 